import React from 'react';
import styled, { css } from 'styled-components';

import { media } from '@/utils/mixin';

interface Props {
  text: string;
}

function TextIntro({ text }: Props) {
  return <Component>{text}</Component>;
}

export default TextIntro;

const Component = styled.div`
  margin: 40px auto 30px;
  padding: 0 20px;
  width: 100%;
  max-width: 67%;

  ${media.tablet(css`
    max-width: 100%;
  `)}

  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    margin-top: 50px;
    margin-bottom: 50px;
  }

  @media (min-width: 1600px) {
    margin-top: 70px;
    margin-bottom: 70px;
    font-size: 26px;
  }
`;
